<template>
  <div>
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item :label="$t('collectionCenter.Barcode')">
            <el-input
              v-model="queryForm.params.waybillNumbers"
              :placeholder="$t('collectionCenter.max2000Line')"
              :rows="5"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <!--定责时间-->
          <el-form-item :label="$t('fixDutyFine.DefiniteTime')">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :placeholder="$t('newOrder.SelectDatetime')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  区域   -->
          <el-form-item :label="$t('placeOrder.area')">
            <el-select
              v-model="queryForm.params.regions"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  责任环节   -->
          <el-form-item :label="$t('fixDutyFine.ResponsibleLink')">
            <el-select
              v-model="queryForm.params.processes"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in linkResponsibility"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 28px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm()"
            >{{ $t('newOrder.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      :data="totalData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column :label="$t('placeOrder.area')" align="center" prop="region" />
      <el-table-column :label="$t('newOrder.Total')" align="center" prop="totalCount">
        <template slot-scope="scope">
          <div style="color: #00A551; cursor: pointer" @click="toSearch(scope.row, null)">
            {{ scope.row.totalCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('fixDutyFine.frontEndCollection')"
        align="center"
        prop="frontPickupCount"
      >
        <template slot-scope="scope">
          <div style="color: #00A551; cursor: pointer" @click="toSearch(scope.row, 'FRONT_PICKUP')">
            {{ scope.row.frontPickupCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('fixDutyFine.hubOperation')"
        align="center"
        prop="hubOperationCount"
      >
        <template slot-scope="scope">
          <div
            style="color: #00A551; cursor: pointer"
            @click="toSearch(scope.row, 'HUB_OPERATION')"
          >
            {{ scope.row.hubOperationCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('fixDutyFine.collectionTransport')"
        align="center"
        prop="pickupTransportCount"
      >
        <template slot-scope="scope">
          <div
            style="color: #00A551; cursor: pointer"
            @click="toSearch(scope.row, 'PICKUP_TRANSPORT')"
          >
            {{ scope.row.pickupTransportCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('fixDutyFine.glpUnloading')" align="center" prop="glpUnloadCount">
        <template slot-scope="scope">
          <div style="color: #00A551; cursor: pointer" @click="toSearch(scope.row, 'GLP_UNLOAD')">
            {{ scope.row.glpUnloadCount }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="flx-between" style="margin: 10px 0">
      <div>
        <span>{{ $t('navbar.gong') }}</span>
        <span style="margin: 0 5px; color: #00A551">{{ queryForm.total }}</span>
        <span>{{ $t('fixDutyFine.Item') }}</span>
      </div>
      <el-button
        size="small" type="primary" @click="allExportOrder"
      >{{ $t('navbar.export') }}
      </el-button>
    </div>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="70"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {
  fmLiabilityPage,
  getTimelinessTotal,
  timelinessDetailsExport
} from '@/api/definiteResponsibilityAndPenalty';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'DurationTransit',
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          waybillNumbers: '',
          regions: [],
          processes: []
        }
      },
      tableData: [],
      totalData: [],
      tableHeaderList: [
        // 条形码
        {
          id: 1,
          label: this.$t('collectionCenter.Barcode'),
          prop: 'scanNumber',
          cloWidth: '160',
          center: 'center'
        },
        // 定责时间
        {
          id: 2,
          label: this.$t('fixDutyFine.DefiniteTime'),
          prop: 'dutyTime',
          cloWidth: '150',
          center: 'center'
        },
        // 定责类型
        {
          id: 15,
          label: this.$t('fixDutyFine.DefiniteType'),
          prop: 'dutyTypeName',
          cloWidth: '150',
          center: 'center'
        },
        // 区域
        {
          id: 3,
          label: this.$t('placeOrder.area'),
          prop: 'region',
          cloWidth: '100',
          center: 'center'
        },
        // 延误的流程
        {
          id: 4,
          label: this.$t('fixDutyFine.delayedProcess'),
          prop: 'processName',
          cloWidth: '150',
          center: 'center'
        },
        // 责任人
        {
          id: 24,
          label: this.$t('GlobalSetObj.PersonInCharge'),
          prop: 'dutyPerson',
          cloWidth: '150',
          center: 'center'
        },
        // 预计操作时长
        {
          id: 5,
          label: this.$t('fixDutyFine.estimatedOperationDuration'),
          prop: 'estimatedHours',
          cloWidth: '150',
          center: 'center'
        },
        // 实际操作时长
        {
          id: 6,
          label: this.$t('fixDutyFine.actualOperationDuration'),
          prop: 'actualHours',
          cloWidth: '160',
          center: 'center'
        },
        // 延误时长
        {
          id: 7,
          label: this.$t('fixDutyFine.delayDuration'),
          prop: 'delayHours',
          cloWidth: '150',
          center: 'center'
        }
      ],
      ruleForm: {
        state: '',
        transferType: 4, // 中转类型  1:揽收装车时间 2:一级分拣中心中转时长 3:二级分拣中心中转时长 4:网点派送时长
        businessType: 0, // 业务类型 0：正常快递 1：大件快递
        siteId: '',
        townType: '', // 城镇类型 1:农村 2:市区  3:州府
        duration: '' // 时长 单位小时  1位小数
      },
      multipleSelection: [],
      areaList: [
        { label: 'SP', value: 'SP' },
        { label: 'JAU', value: 'JAU' },
        { label: 'Franca', value: 'Franca' },
        { label: 'RJ', value: 'RJ' },
        { label: 'MG', value: 'MG' }
      ],
      linkResponsibility: [
        { label: this.$t('fixDutyFine.frontEndCollection'), value: 'FRONT_PICKUP' },
        { label: this.$t('fixDutyFine.hubOperation'), value: 'HUB_OPERATION' },
        { label: this.$t('fixDutyFine.collectionTransport'), value: 'PICKUP_TRANSPORT' },
        { label: this.$t('fixDutyFine.glpUnloading'), value: 'GLP_UNLOAD' }
      ],
      toColumn: null,
      toArea: null
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '180px' : '110px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
  },
  methods: {
    // 查询条件整理
    queryParam() {
      const params = {
        startTime: null,
        endTime: null,
        scanNumbers: [],
        regions: this.queryForm.params.regions,
        processes: this.queryForm.params.processes
      };

      if (this.toColumn) {
        params.processes = [this.toColumn];
      }
      if (this.toArea) {
        params.regions = [this.toArea];
      }
      if (this.timeValue && this.timeValue.length > 0) {
        params.startTime = this.timeValue[0];
        params.endTime = this.timeValue[1];
      }
      if (this.queryForm.params.waybillNumbers) {
        params.scanNumbers = this.queryForm.params.waybillNumbers
          .split(/[\n\r]+/) // 按换行符分割，支持多种换行符组合
          .map((item) => item.trim()) // 去除首尾空格
          .filter(Boolean); // 过滤空字符串
      }
      return params;
    },
    // 查询
    getSearch() {
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params = this.queryParam();
        if (data.params.scanNumbers.length > 2000) {
          this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
          return;
        }
      } else {
        data.params = this.queryParam();
        if (!this.queryForm.params.waybillNumbers) {
          this.$message.error(this.$t('fixDutyFine.selectTimeRange'));
          return;
        }
      }
      fmLiabilityPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.getTimelinessTotal();
        }
      });
    },
    // 调用汇总
    getTimelinessTotal() {
      const data = this.queryParam();
      getTimelinessTotal(data).then((res) => {
        if (res.code === 200) {
          this.totalData = res.data;
        }
      });
    },
    // 获取最近一周时间
    getTimer() {
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.toArea = null;
      this.toColumn = null;
      this.getSearch();
    },
    toSearch(row, column) {
      this.queryForm.pageNumber = 1;
      console.log(row, column);
      this.toColumn = column;
      if (row.region !== '总计') {
        this.toArea = row.region;
      } else {
        this.toArea = null;
      }
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        regions: [],
        processes: []
      };
      this.toArea = null;
      this.toColumn = null;
      this.getSearch();
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    allExportOrder() {
      let data = {};
      if (this.timeValue && this.timeValue.length > 0) {
        data = this.queryParam();
        if (data.scanNumbers.length > 2000) {
          this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
          return;
        }
      } else {
        data = this.queryParam();
        if (!this.queryForm.params.waybillNumbers) {
          this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
          return;
        }
      }
      timelinessDetailsExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.textOperator {
  color: #00A551;
  cursor: pointer;
  font-size: 22px;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #00A551;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}
</style>
